/**
 * @author Fernando Ruano
 * @file routes.js
 * @description CountryUserRoles routes
 */

// Pages
import CountryUserRolesManagement from '@nephro/pages/CountryUserRoles/CountryUserRolesManagement';
import CountryUserRolesCreation from '@nephro/pages/CountryUserRoles/CountryUserRolesCreation';
import CountryUserRolesViewEdit from '@nephro/pages/CountryUserRoles/CountryUserRolesViewEdit';

const pathStart = '/main/users-management';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: CountryUserRolesManagement,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: CountryUserRolesCreation,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: CountryUserRolesViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: CountryUserRolesViewEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
